import { ServiceTypeService } from './../../services/serviceTypeService';
import { Component, OnInit } from '@angular/core';
import { ServiceType } from '../../models/serviceType';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-update-service-type',
  templateUrl: './update-service-type.component.html',
  styleUrls: ['./update-service-type.component.css'],
})
export class UpdateServiceTypeComponent implements OnInit {
  sType: ServiceType;
  isLoading: boolean = false;
  constructor(
    private service: ServiceTypeService,
    private diag: NbDialogRef<UpdateServiceTypeComponent>,
    private toast: NbToastrService,
    private route: Router
  ) {
    this.sType = {} as ServiceType;
  }

  ngOnInit(): void {
    this.route.events.subscribe(() => {
      this.diag.close('false');
    });
  }

  save() {
    this.isLoading = true;
    this.service.put(this.sType.id, this.sType).subscribe((res) => {
      this.isLoading = false;
      this.toast.show('تم تعديل نوع الخدمة  بنجاح', '', { status: 'success', duration: 4000 });
      this.diag.close('true');
    });
  }
}
